export enum TissueReportSlugs {
    ThreeToSixMonthFollowUp = "three-to-six-month-follow-up",
}
